import RuleModel from "./rule.model"
import Condition_class from "../shared/classes/condition_class"

class ExplainConditionModel {
  constructor (rule) {
    console.log(rule)
    this.rule = Reflect.construct(RuleModel, [rule])
    this.explainCondition = {}
  }

  init () {
    Reflect.set(
      this.explainCondition,
      "start",
      `Если при совершении операции ${this.rule.operationHuman}, одновременно выполнятся следующие условия:`
    )
    return this
  }

  add (condition, conditionParameterList) {
    // const localCondition = Reflect.construct(Condition_class, [condition])
    const localCondition = new Condition_class(condition).conditionParameters(conditionParameterList).item
    Reflect.set(
      this.explainCondition,
      condition.conditionId,
      `${localCondition.parameterHuman} ${localCondition.comparisonOpHuman} ${condition.value}`
    )
    return this
  }

  delete (condition) {
    Reflect.deleteProperty(this.explainCondition, condition.conditionId)
    return this
  }

  end () {
    if (!Reflect.has(this.explainCondition, "end")) {
      Reflect.set(
        this.explainCondition,
        "end",
        `Тогда бонус составит ${this.rule.accrualAmount}, в единицах измерения - ${this.rule.accrualTypeHuman}`
      )
    }
    return this
  }

  getExplain () {
    return this.explainCondition
  }
}

export default ExplainConditionModel
